import { Form, withFormik, useField } from "formik";
import FormikDropdownAutoComplete from "../../components/formik/FormikDropdownAutoComplete";
import * as Yup from "yup";
import FormikDropdown from "../../components/formik/FormikDropdown";
import DropdownAutoComplete from "../../components/DropdownAutoComplete";
import { Toolbar, Tabs, Tab, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import _, { cloneDeep, isEmpty } from "lodash";
import WolkenEditor from "../../components/WolkenEditor";
import FormikInput from "../../components/formik/FormikInput";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Input, Button, Dropdown} from "../../components";
import { colors } from "../../theme/variables";
import * as Icons from "@material-ui/icons";
import { getCategories } from "../../data/services/API";
import InputParams from "../../components/forms/taskParams/InputParams";
import { Tooltip} from '@material-ui/core';
import { useWorkflowNames ,useWorkflowDefWithEnabled , useLatestWorkflowDef} from "../../data/workflow";

const KeyParams = (props) => {
  const {
    deleteParam,
    index,
    keyParam,
    updateParam
  } = props;
  const [value, setValue] = useState(keyParam ? keyParam : "");

  const handleInputChange = (val) => {
    setValue(val);
    updateParam(index, val);
  }

  useEffect(() => {
    setValue(keyParam);
  },[keyParam])

  return (
    <Grid
      container
      spacing={2}
      alignItems="baseline"
      justifyContent="center"
      key={index}>
      <Grid item xs={11}>
        < Input
          placeholder="e.g.: Cache-Control..."
          fullWidth
          label="Key"
          value={value}
          onChange={handleInputChange}
        />
      </Grid>
      <Grid
        item
        xs={1}
        style={{ alignSelf: "center" }}>
        <div
          // className={classes.iconContainer}
          onClick={() => deleteParam(index)}
          style={{ color: colors.red07, cursor: "pointer" }}>
          <Icons.DeleteOutlineOutlined />
        </div>
      </Grid>
    </Grid>
  );

}


const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    height: "100%",
    alignItems: "stretch",
    flexDirection: "column",
  },
  name: {
    fontWeight: "bold",
  },
  rightButtons: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    gap: 8,
  },
  workflowDefTabs: {
    // marginBottom: "1rem",
  },
  workflowDefTabPannels: {
    height: "calc(100vh - 9rem)", //subtracted hieght for tab header and toolbar
    overflow: "auto",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    // backgroundColor: "#fff",
    // height: "100vh",
  },
  multiline:{
    "& .MuiOutlinedInput-multiline":{
      padding: 0
    }
  },
  fields: {
    width: "100%",
    height: "100%",

    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    gap: 15,
  },
  formLabel: {
    fontSize: "13px",
    fontWeight: 600,
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "20px",
    cursor: "pointer",
  },
  icon: { cursor: "pointer" },
  switchContainer: { marginLeft: 0 },
  switchRoot: { marginRight: "1rem" },
  rootBox: {
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "4px",
    backgroundColor: "rgb(255, 255, 255)",
  },
  monaco: {
    padding: 10,
    width: "100%",
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: "rgb(255, 255, 255)",
    "&:focus-within": {
      margin: -2,
      borderColor: "rgb(73, 105, 228)",
      borderStyle: "solid",
      borderWidth: 2,
    },
  },
});

const TaskDefTasks = (props) => {
  const classes = useStyles();
  const {
    inputFields,
    values,
    setData,
    setFieldValue,
    handleTasks,
    data, 
    errors,
    jsonErrors,
    setJsonErrors,
    setValues,
    taskName
  } = props;

  useEffect(() => {
    setJsonErrors(errors);
  },[errors])

  useEffect(() => {
    let timeout;
    // sort the 2 objs 
    const sorted_data = Object.keys(data)
    .sort().reduce((temp_obj, key) => {
      temp_obj[key] = data[key];
      return temp_obj;
    }, {});

    const sorted_values = Object.keys(values)
    .sort().reduce((temp_obj, key) => {
      temp_obj[key] = values[key];
      return temp_obj;
    }, {});

    if(!_.isEqual(sorted_data, sorted_values)){
      const payload = _.cloneDeep(sorted_values);
      inputFields.forEach(field => {
        const fieldParam = field.field;
        if (field.fieldType === "Select" && typeof sorted_values[fieldParam] !== "string") {
          payload[fieldParam] = _.get(sorted_values, fieldParam, "")?.value ?? "";
        }
      })
      timeout = setTimeout(() => {
        handleTasks(payload);
      }, 1000);
    }
    return () => clearTimeout(timeout);
  }, [values]);

  useEffect(() => {
    if(!_.isEqual(data, values) && !isEmpty(data)){
    setValues(data)
    // Object.assign(values,data);
    }
  },[data]);

  // getCategories
  const [category , setCategory] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [taskAction, setTaskAction] = useState("1");
  const [workflow, setWorkflow] = useState("");

  useEffect(()=>{
    async function fetchData() {
      const categories = await getCategories();
      setCategory(categories?.data ? categories.data : []);
    }
    fetchData();
  },[]);

   const { data: wfNames, refetch: refetchWfNames , isFetching :isFetchingwfNames } = useWorkflowNames();
   const { data: wfData ,refetch: refetchWfDefs , isFetching :isFetchingwfDefs } = useLatestWorkflowDef(
    workflow,
    { enabled: !!(workflow ) && !Array.isArray(workflow)}
  );


  const memoizedUniqueTasks = useMemo(() => {
    if (!wfData?.tasks) return [];
    
    const tasks = cloneDeep(wfData.tasks);
    return Array.from(new Set(tasks.map(task => task.name)));
  }, [wfData]);
  
  useEffect(() => {
    setTasks(memoizedUniqueTasks);
  }, [memoizedUniqueTasks]);


  const handleEditorChange = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  function updateKeyParam(index, value, fieldName){
    const fieldVal = values[fieldName] ? _.cloneDeep(values[fieldName]) : [];
    fieldVal[index] = value;
    setFieldValue(fieldName, fieldVal);
  }

  function deleteKeyParm(index, fieldName){
    const fieldVal = values[fieldName] ? _.cloneDeep(values[fieldName]) : [];
    fieldVal.splice(index, 1);
    setFieldValue(fieldName, fieldVal);
  }

  function addKeyParam(fieldName){
    const fieldVal = values[fieldName] ? values[fieldName] : [];
    setFieldValue(fieldName, [...fieldVal, '']);
  }

  function deleteInputParam(index, fieldName){
    let temp = { ...values[fieldName] };
    temp = Object.entries(temp);
    temp = temp.filter((e, idx) => idx !== index);
    setFieldValue(fieldName, Object.fromEntries(temp));
  }

  function updateInputParam(index, param ,val, fieldName){
    let temp = { ...values[fieldName] };
    temp = Object.entries(temp);

    temp[index][0] = param || "";
    temp[index][1] = typeof val === "boolean" || val === null || val ? val : "";

    setFieldValue(fieldName, Object.fromEntries(temp));
    
  }

  function addInputParam(fieldName){
    let obj = { "": "" };
    setFieldValue(fieldName, { ...values[fieldName], ...obj });
  }

  // Divide inputFileds by groupName 
  const inputFieldsByGroup = _.groupBy(inputFields, (obj) => obj.groupName);

  const GRID_ITEMS = (fields) =>  fields.length ? fields
  .filter((obj) => obj?.hide?.toLowerCase() === "false")
  .map((inputField, i) => {
    switch (inputField.fieldType) {
      case "Select":
        let selectOptions = inputField.options ? inputField.options : [];
        let defaultValue = inputField.defaultValue;
        let filteredDefaultValueObj = selectOptions.filter(
          (opt) => opt.value === defaultValue
        )[0];

        if(inputField.field === 'category'){
          selectOptions = category.map(op => {
            return ({
              value: op,
              key: op,
            })
          });
        }

        return (
          <Grid
          style={{width: '100%'}}
            item
            key={`${"task"}_${
              inputField.field
            }_${i}`}>
              {typeof selectOptions[0] === "object" ? (
                    <FormikDropdownAutoComplete
                      options={selectOptions}
                      name={inputField.field}
                      label={inputField.fieldLabel}
                      defaultValue={filteredDefaultValueObj || ""}
                      required={["yes", "true"].includes(
                        inputField?.isMandatory?.toLowerCase()
                      )}
                      tooltip = {inputField?.tooltip ? inputField.tooltip : ''}
                    />
                  ) : (
                    <FormikDropdown
                      id={`${ "task"}_${
                        inputField.field
                      }_${i}`}
                      label={inputField.fieldLabel}
                      name={inputField.field}
                      variant="outlined"
                      fullWidth
                      freeSolo
                      autoSelect
                      defaultValue={filteredDefaultValueObj || ""}
                      getOptionLabel={(option) => option ?? option}
                      options={selectOptions}
                      required={["yes", "true"].includes(
                        inputField?.isMandatory?.toLowerCase()
                      )}
                    />
                  )}
            </Grid>);
      
      case "RTE":
        return (
          <Grid
            key={`${"task"}_${inputField.field}_${i}`}
            style={{ width: "100%", padding: "4px" }}>
            <WolkenEditor
              waterMark={inputField.fieldLabel}
              handleEditorChange={(value) => {
                handleEditorChange(inputField.field, value);
              }}
              label={inputField.fieldLabel}
              id={`${"task"}_${
                inputField.field
              }_${i}`}
              taskReferenceName={values.taskReferenceName}
              name={inputField.field}
              value={values[inputField.field]}
              required={["yes", "true"].includes(
                inputField?.isMandatory?.toLowerCase()
              )}
            />
          </Grid>
      );

      case 'keyParams': 
      return (
        <Grid
        key={`${"task"}_${inputField.field}_${i}`}
        style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
          <div className='flex-row' style={{alignItems: 'center'}}>
            <label>{inputField.fieldLabel}</label>
            {inputField.tooltip ? (<Tooltip title={inputField.tooltip} arrow>
            <Icons.Help style={{verticalAlign: "middle", fontSize: "16px",marginLeft:"5px",marginBottom:"5px"}} color="primary" /></Tooltip>): null}
          </div>
           {values[inputField.field].length
            ? values[inputField.field].map((val, index) =>(
              <KeyParams
              key={`${"task"}_${inputField.field}_${i}_${index}`}
              index={index}
              deleteParam = {(ind) => deleteKeyParm(ind, inputField.field)}
              updateParam = {(ind, value) => updateKeyParam(ind, value, inputField.field)}
              keyParam = {val}></KeyParams>
            )) : ''}
            <Button
            style={{ width: "fit-content", marginTop: "8px", padding: '4px 8px' }}
            onClick={() => addKeyParam(inputField.field)}
          >
            <Icons.Add /> Add Key
          </Button>
      </Grid>
      );
      
      case 'inputParams':
        return(
          <Grid item key={`${"task"}_${inputField.field}_${i}`} style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
          <div className='flex-row' style={{alignItems: 'center'}}>
            <label>{inputField.fieldLabel}</label>
            {inputField.tooltip ? (<Tooltip title={inputField.tooltip} arrow>
            <Icons.Help style={{verticalAlign: "middle", fontSize: "16px",marginLeft:"5px",marginBottom:"5px"}} color="primary" /></Tooltip>): null}
          </div>
          {Object.entries(values[inputField.field]).length
            ? Object.entries(values[inputField.field]).map((keyVal, index) => (
                <InputParams
                  pageType="Event"
                  key={index}
                  classes={classes}
                  deleteParam={(ind) => deleteInputParam(ind, inputField.field)}
                  updateParam={(ind, param, value) => updateInputParam(ind, param, value, inputField.field)}
                  keyVal={keyVal}
                  index={index}
                  param={values[inputField.field]}
                />
              ))
            : ""}
          <Button style={{ width: "fit-content", marginTop: "8px", padding: '4px 8px' }} onClick={() => addInputParam(inputField.field)}>
            <Icons.Add /> Add Parameter
          </Button>
        </Grid>
        )

      default:
        const item = (
          <Grid
            item
            key={`${"task"}_${
              inputField.field
            }_${i}`} style={{width: '100%'}}>
            <FormikInput
              id={`${"task"}_${
                inputField.field
              }_${i}`}
              required={["yes", "true"].includes(
                inputField?.isMandatory?.toLowerCase()
              )}
              label={inputField.fieldLabel}
              variant="outlined"
              name={inputField.field}
              fullWidth
              className={inputField.fieldType === 'textarea' ? classes.multiline : ""}
              type={typeof inputField.defaultValue === 'number' ? 'number': 'text'}
              tooltip = {inputField?.tooltip ? inputField.tooltip : ''}
              multiline = {inputField.fieldType === 'textarea'}
              minRows={inputField.fieldType === 'textarea' ? 2 : 1}
              maxRows={inputField.fieldType === 'textarea' ? 4 : 1}
            />
          </Grid>
        );
        const field = (
          <Grid
          item
          key={`${"task"}_${
            inputField.field
          }_${i}`} style={{width: '100%'}}>
                   <FormikDropdown
                      id={`${ "task"}_${
                        inputField.field
                      }_${i}`}
                      label={inputField.fieldLabel}
                      name={inputField.field}
                      variant="outlined"
                      fullWidth
                      freeSolo
                      autoSelect
                      getOptionLabel={(option) => option ?? option}
                      options={tasks?tasks:[]}
                      required={["yes", "true"].includes(
                        inputField?.isMandatory?.toLowerCase()
                      )}
                 loading = {isFetchingwfDefs}
                        type="string"
                    />
        </Grid>
        )
        if (
          inputField.field !== "header" &&
          inputField.field !== "body"
        ) {
          if (inputField.isMandatory !== "Conditional") {
          
            if (inputField.field === "name") {
             
              // Conditionally render based on taskAction
              return taskAction === "2" ? field : item;
            }
            var returnItem = true;
            return returnItem && item;
          } else if (inputField.isMandatory === "Conditional") {
            if (
              values &&
              inputField.refValues !== undefined &&
              checkRefValue(
                inputField.refValues,
                inputField.refField,
                values
              )
            ) {
              return item;
            }
          }
          return "";
        }
    }
  }) : '';

  const items = Object.keys(inputFieldsByGroup).map(group => {
    return (
      <div style={{width: inputFieldsByGroup[group][0] && inputFieldsByGroup[group][0].groupWidth ?  inputFieldsByGroup[group][0].groupWidth : '49%', padding:'0.5% 1%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
        <h3 style={{marginBottom: inputFieldsByGroup[group][0].groupWidth === '100%' && '0'}}>{group}</h3>
        {GRID_ITEMS(inputFieldsByGroup[group])}
      </div>
    )
  })

  function renderTaskActionSection() {
    if (taskName) return null;
    return (
      <div style={{ width: '100%', padding: '0.5% 1%', display: 'flex', flexDirection: "column" }}>
        <h3>Select Task Action</h3>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}  >
            <DropdownAutoComplete
              label="Select Task Action"
              options={[
                { key: "New Task Definition", value: "1" },
                { key: "Fetch tasks from existing workflows", value: "2" }
              ]}
              required
              value={taskAction}
              onChange={(event, newValue) => {
                if (newValue && typeof newValue === "object")
                  {
                    setTaskAction(newValue.value)
                  } 
                else {
                  setTaskAction("1")
                }
                setWorkflow("")
                setFieldValue("name", "")
              }}
            />
          </Grid>

          {taskAction === "2" &&
            <Grid item xs={6}>
              <Dropdown
                label="Select the Workflow"
                options={wfNames ? wfNames : []}
                variant="outlined"
                freeSolo
                fullWidth
                value={workflow}
                onChange={(event, newValue) => {
                  setWorkflow(newValue);
                  setFieldValue("name", "")
                }}
                loading={isFetchingwfNames}
                type="string"
              />
            </Grid>
          }
        </Grid>
      </div>
    )
  }

  return (
    <>
    {renderTaskActionSection()}
    <Form className={classes.main}>
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        {items}
      </div>
    </Form>
    </>
  );
}

function checkRefValue(refValues, refField, values) {
  const value = values[refField];
  if (!value) return false;
  return (
    refValues.includes(values[refField]) || refValues.includes(value.value)
  );
}

function customTaskPayloadToFormData(data,inputFields) {
  let obj = {};

  inputFields.forEach((inputField) => {
    const fieldName = inputField.field;
    const fieldType = inputField.fieldType;
    const path = inputField.path;
    const defaultVal = inputField.defaultValue;

      switch (fieldType) {
        case "Select":
          const selectOptions = inputField.options ? inputField.options : [];
          const selectDefaultValue = inputField.defaultValue;
          const selectFilteredDefaultValueObj = selectOptions.filter(
            (opt) => opt.value === selectDefaultValue
          )[0];

          if (path !== "root") {
            obj[fieldName] = _.get(_.get(data, path), fieldName) ||
              selectFilteredDefaultValueObj?.value;
          }else {
            obj[fieldName] = _.get(data, fieldName) || selectFilteredDefaultValueObj?.value;
          }
          break;

        default:
          if (path !== "root") {
            obj[fieldName] = _.get(_.get(data, path), fieldName) ||
              "";
          } else {
            obj[fieldName] = _.get(data, fieldName) || "";
          }
      }

      if(!_.isNull(defaultVal) && !_.isUndefined(defaultVal) && !data?.name){
        obj[fieldName] = defaultVal;
      }
  });

  if (data) {
    Object.keys(data).forEach(key => {
      if (!Object.keys(obj).includes(key)) {
        obj[key] = data[key];
      }else{
        obj[key] =  obj[key];
      }
    });
  }
  return obj;
}

function isObjEmpty(obj) {
  let isEmpty = false;
  if (_.isEmpty(obj) || _.isUndefined(obj)) return true;
  for (let key in obj) {
    if (_.isEmpty(key) || _.isEmpty(obj[key])) {
      isEmpty = true;
    }
  }
  return isEmpty;
}


function customValidationSchema(inputFields) {
  const validationSchemaObj = {};
  inputFields.forEach((field) => {
    const fieldParam = field.field;
    const mandatoryField = field.isMandatory.toLowerCase() === "yes";
    if (mandatoryField) {
      if (fieldParam === "inputKeys" || fieldParam === "outputKeys") {
        validationSchemaObj[fieldParam] = Yup.object().test(
          "at-least-one-non-empty-field",
          "Required",
          (values) => {
            // if the values are empty
            return !isObjEmpty(values);
          }
        );
      } else if (fieldParam === "name") {
        validationSchemaObj[fieldParam] = Yup.string()
          .max(50, "Name must be at most 50 characters")
          .required("Required")
          .nullable();
      } else if (
        (field.fieldType === "Select" &&
          ((field.options?.length &&
          typeof field.options[0] === "object") || fieldParam === 'category'))) {
        validationSchemaObj[fieldParam] = Yup.object()
        .shape({
          value: Yup.string().required(),
          key: Yup.string().required(),
        })
        .nullable()
      }else {
        validationSchemaObj[fieldParam] = Yup.string()
          .required("Required")
          .nullable();
      }
    }
    else if (
      field.fieldType === "Select" &&
      field.options?.length &&
      typeof field.options[0] === "object"
    ) {
      validationSchemaObj[fieldParam] = Yup.object().nullable();
    }
  });

  const ValidationSchema = Yup.object(validationSchemaObj);
  return ValidationSchema;
}

export default withFormik({
  enableReinitialize: false, //fix for form validation resetting on every re-render
  mapPropsToValues: (props) => {
    return customTaskPayloadToFormData(
      _.get(props, "data"),
      _.get(props, "inputFields"),
    );
  },
  validationSchema: (props) => 
    customValidationSchema(
      _.get(props, "inputFields"),
    ),
})(TaskDefTasks);